import { render, staticRenderFns } from "./field.vue?vue&type=template&id=59ecab05&scoped=true&lang=pug&"
import script from "./field.vue?vue&type=script&lang=js&"
export * from "./field.vue?vue&type=script&lang=js&"
import style0 from "./field.vue?vue&type=style&index=0&id=59ecab05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecab05",
  null
  
)

/* custom blocks */
import block0 from "~/lang/formFields?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928163347%2Fcomponents%2Fwidgets%2Fforms%2Ffield.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./field.vue?vue&type=custom&index=1&blockType=i18n"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsAddress: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/address.vue').default,WidgetsFormsMultiCheckbox: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/multi-checkbox.vue').default,WidgetsFormsMoney: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/money.vue').default,WidgetsFormsPercent: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/percent.vue').default,WidgetsFormsTypeahead: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/typeahead.vue').default,WidgetsFormsInput: require('/home/ubuntu/nuxt/bonkers/releases/20230928163347/components/widgets/forms/input.vue').default})
